import React from 'react'
import styles from './ExecutiveSummary.module.css'

const priorityColors = {
  exercise: '#f5222d',
  nutrition: '#52c41a',
  sleep: '#1677ff'
}

const priorityIcons = {
  exercise: <span role="img" aria-label="exercise">🏋️</span>,
  nutrition: <span role="img" aria-label="nutrition">🥗</span>,
  sleep: <span role="img" aria-label="sleep">😴</span>
}

const getScoreColor = (score, target) => {
  if (!target || target === 0) return '#6b7280'
  const pct = (score / target) * 100
  if (pct >= 85) return '#52c41a'
  if (pct >= 70) return '#1677ff'
  if (pct >= 55) return '#faad14'
  return '#f5222d'
}

const getPriorityStyle = (priority) => {
  const p = (priority || 'medium').toLowerCase()
  const styles = {
    high: { text: '#ef4444', bg: '#fef2f2' },
    medium: { text: '#f59e0b', bg: '#fffbeb' },
    low: { text: '#22c55e', bg: '#f0fdf4' }
  }
  return styles[p] || styles.medium
}

const ExecutiveSummaryPillar = ({ pillarKey, title, pillarData }) => {
  if (!pillarData) return null

  const accent = priorityColors[pillarKey] || '#6b7280'
  const icon = priorityIcons[pillarKey] || <span role="img" aria-label="chart">📊</span>
  const pct = pillarData.target_score ? Math.round((pillarData.score / pillarData.target_score) * 100) : 0
  const scoreColor = getScoreColor(pillarData.score, pillarData.target_score)
  const priorityStyle = getPriorityStyle(pillarData.priority)

  return (
    <div className={styles.pillarCard} style={{ borderTopColor: accent }}>
      <div className={styles.pillarHeader}>
        <div className={styles.pillarTitleSection}>
          <div className={styles.pillarIcon} style={{ backgroundColor: `${accent}18`, color: accent }}>
            {icon}
          </div>
          <div>
            <div className={styles.pillarTitle}>{title}</div>
            <span
              className={styles.priorityBadge}
              style={{ color: priorityStyle.text, backgroundColor: priorityStyle.bg }}
            >
              {pillarData.priority.toUpperCase()} PRIORITY
            </span>
          </div>
        </div>
        <div className={styles.pillarScoreSection}>
          <div className={styles.pillarScore} style={{ color: scoreColor }}>
            {pillarData.score}
            <span className={styles.pillarScoreFraction}> / {pillarData.target_score}</span>
          </div>
        </div>
      </div>

      <div className={styles.progressSection}>
        <div className={styles.progressBarBg}>
          <div className={styles.progressBarFill} style={{ width: `${pct}%`, backgroundColor: accent }} />
        </div>
      </div>

      <h3 className={styles.headline}>{pillarData.headline}</h3>
      <p className={styles.status}>{pillarData.current_status}</p>

      {pillarData.quick_actions && pillarData.quick_actions.length > 0 && (
        <ul className={styles.actionsList}>
          {pillarData.quick_actions.slice(0, 3).map((action, idx) => (
            <li key={idx} className={styles.actionItem}>
              <span role="img" aria-label="lightning" className={styles.actionIcon}>⚡</span>
              {action}
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default ExecutiveSummaryPillar
